import { InFilterDefinition } from '@factorialco/f0-react'
import {
  ImportHistoryImportedByFilterDocument,
  ImportHistoryImportedByFilterQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import i18n from 'modules/core/lib/i18n'

const extractConnection = (data: ImportHistoryImportedByFilterQuery) =>
  data.employees.employeeNamesConnection

const extractNodes = (connection: ReturnType<typeof extractConnection>) =>
  connection.edges.map((edge) => edge.node)

type Node = ReturnType<typeof extractNodes>[number]

export const useImportedByFilter = (): InFilterDefinition<string> => {
  const { company } = useCurrentSession()
  const companyId = company.id

  const source = useGraphqlDataSource(
    {
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      document: ImportHistoryImportedByFilterDocument,
      perPage: 25,
      mapData: (data) => extractNodes(extractConnection(data)),
      mapPagination: (data) => {
        const connection = extractConnection(data)
        const pageInfo = connection.pageInfo

        return {
          total: connection.totalCount ?? 0,
          cursor: pageInfo.endCursor ?? '0',
          hasNextPage: !!pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ search }) => ({
        search,
        companyId,
      }),
    },
    [companyId]
  )

  return {
    label: i18n.t('universal_importer.import_history.table.filters.imported_by.title'),
    type: 'in' as const,
    options: {
      source,
      mapOptions: (employee: Node) => ({
        label: employee.fullName,
        value: employee.accessId,
      }),
    },
  }
}
